export const queryKeys = {
    HOME_VIEW:"HOME_VIEW"
}